import { ReviewItem } from "~/components/Reviews/reviews.types";
import { Stars } from "~/components/Stars/Stars";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import ReadMore from "~/components/ReadMore/ReadMore";
import { TemplateType } from "@commons-monorepo/index";
import styles from "./review.module.css";
import { useGlobalStyles } from "~/styles/context/global-styles-wrapper";
require("dayjs/locale/es");
dayjs.locale("es");
dayjs.extend(localizedFormat);

type Props = {
  review: ReviewItem;
  skin?: string;
};

export const Review = ({
  review,
  skin = TemplateType.PRODUCT_REVIEWS_SKIN_1
}: Props) => {
  const formattedDate = dayjs(review.scoreDate).format("LL");
  const { theme } = useGlobalStyles();
  return (
    <div
      className={` ${styles.review} ${
      skin === TemplateType.PRODUCT_REVIEWS_SKIN_2 ? styles.reviewSkin2 : ""
      }`}>

      <div className={styles.stars}>
        <Stars color={`${theme.themeColors.button}`} number={review.stars} />
      </div>
      <div className={styles.reviewDate}>{formattedDate}</div>
      {review.customerComments &&
      <div className={styles.description}>
          <ReadMore
          colorText={"#0C1220"}
          text={review.customerComments}
          underLine={true} />

        </div>}

    </div>);

};